export default "{\n    \"pageTitle\": \"Nouveau bon de travail\",\n    \"heading\": \"Créer un bon de travail\",\n    \"submitButtonLabel\": \"Soumettre\"\n}\n"